export const SET_REFERRAL_PAGE = 'SET_REFERRAL_PAGE';
export const SET_REFERRAL_INFO = 'SET_REFERRAL_INFO';
export const PAYMENT_REQUEST_ATTEMPT = 'PAYMENT_REQUEST_ATTEMPT';
export const PAYPAL_REQUEST = 'PAYPAL_REQUEST';



// WEBPACK FOOTER //
// ./app/actions/support.js